import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as _ from 'lodash';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ReqManagerCreateActions } from '../actions';
import { OnboardingProductsService } from '../../services/onboarding-products.service';
import { Common } from './common';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../store';

@Injectable()
export class ReqManagerCreateffects {
  constructor(
    private actions$: Actions,
    private onboardingProductsService: OnboardingProductsService,
    private store: Store<OnboardingProductsStore.AppState>
  ) {}

  private common = new Common();

  getReqManagerCreate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ReqManagerCreateActions.getReqManagerCreate),
      switchMap((action) =>
        this.onboardingProductsService.getReqManagerCreate(action.request).pipe(
          map((res) => this.common.responseInterpreter(res)),
          map((res) => res['middleware']),
          map((res) =>
          ReqManagerCreateActions.getReqManagerCreateSucess({ response: res })
          ),
          catchError((error) =>
            of(
              ReqManagerCreateActions.getReqManagerCreateError({
                payload: this.common.handleErrorsDefault(error)
              })
            )
          )
        )
      )
    )
  );

}
